import { connect } from 'react-redux';
import {
    setFirstName,
    setLastName,
    setEmail,
    setPhone,
    setDeliveryOption,
    setStoreLocation
} from 'Actions/payment';
import { updateValids } from 'Actions/form';
import PaymentForm from './Payment';

const mapStateToProps = (state) => ({
    firstName: state.payment.firstName,
    lastName: state.payment.lastName,
    email: state.payment.email,
    phone: state.payment.phone,
    deliveryOption: state.payment.deliveryOption,
    storeLocation: state.payment.storeLocation,
    valids: state.form.valids,
    nextAttempted: state.form.nextAttempted,
    shippingLocations: state.form.shippingLocations
});

const mapDispatchToProps = (dispatch) => ({
    setFirstName: (first_name) => dispatch(setFirstName(first_name)),
    setLastName: (last_name) => dispatch(setLastName(last_name)),
    setEmail: (email) => dispatch(setEmail(email)),
    setPhone: (phone) => dispatch(setPhone(phone)),
    setDeliveryOption: (delivery_option) => dispatch(setDeliveryOption(delivery_option)),
    setStoreLocation: (store_location) => dispatch(setStoreLocation(store_location)),
    updateValids: (new_valids) => dispatch(updateValids(new_valids))
})

export default connect (mapStateToProps, mapDispatchToProps)(PaymentForm);
